import { render, staticRenderFns } from "./TourReportView.vue?vue&type=template&id=134dcd74&"
import script from "./TourReportView.vue?vue&type=script&lang=js&"
export * from "./TourReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports